export default __webpack_public_path__ + "static/media/stiko.3b9e3732.png";